import { contractYears } from '../utils/contractYear'
import axios from 'axios'

export default {
  data() {
    return {
      salesLines: []
    }
  },
  created() {
    this.fetchSalesLines()
  },
  methods: {
    fetchSalesLines() {
      axios.get('/api/sandoz/sales_lines').then(response => {
        this.salesLines = response.data.data || response.data
        this.updateContractYears()
      })
    },
    getSuggestedStartMonth(type) {
      if (type && this.salesLines) {
        const sl = this.salesLines.find(x => x.sales_line === type)
        if (sl && sl.suggested_start_month !== null && sl.suggested_start_month !== undefined) {
          return sl.suggested_start_month
        }
      }
      
      // Default fallback logic mirroring backend Trait
      if (type && (type.startsWith('KAM_') || type.includes('_KAM_') || type.startsWith('BIOS_KAM_')) && !type.endsWith('_EDU') && !type.endsWith('_GADGET')) {
        return 9
      }
      return 11
    },
    suggestContractYear(suggestedStartMonth) {
      const currentDate = new Date()
      const thresholdMonthIndex = suggestedStartMonth - 1
      if (currentDate.getMonth() >= thresholdMonthIndex) {
        return currentDate.getFullYear() + 1
      }
      return currentDate.getFullYear()
    },
    suggestContractStart(suggestedStartMonth, suggestedYear) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const march31 = new Date(currentYear, 2, 31)
      const thresholdMonthIndex = suggestedStartMonth - 1
      
      if (currentDate < march31 || currentDate.getMonth() >= thresholdMonthIndex) {
        return suggestedYear + '-01-01'
      } else {
        const mm = String(currentDate.getMonth() + 1).padStart(2, '0')
        return currentYear + '-' + mm + '-01'
      }
    },
    updateContractYears() {
      const item = this.item || (this.$refs.form && this.$refs.form.item)
      const type = item ? item.type : null
      const suggestedMonth = this.getSuggestedStartMonth(type)
      const yearsList = contractYears(suggestedMonth)
      
      if (item && item.contract_year) {
        const yearVal = parseInt(item.contract_year)
        if (yearVal && !yearsList.some(y => y.value === yearVal)) {
          yearsList.push({ value: yearVal, text: yearVal.toString() })
          yearsList.sort((a, b) => a.value - b.value)
        }
      }
      this.years = yearsList
    },
    handleTypeChange(newVal) {
      this.updateContractYears()
      if (this.$route.params.id === 'new' && newVal) {
        const suggestedMonth = this.getSuggestedStartMonth(newVal)
        const suggestedYear = this.suggestContractYear(suggestedMonth)
        const item = this.item || (this.$refs.form && this.$refs.form.item)
        if (item) {
          item.contract_year = suggestedYear
          item.contract_start = this.suggestContractStart(suggestedMonth, suggestedYear)
          item.contract_expiration = suggestedYear + '-12-31'
        }
        this.updateContractYears()
      }
    }
  }
}
